"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchers = void 0;
var linkedFoldersActions = require("@caddigital/sok-reducers/lib/actions/vektorio/linkedFolders");
var linkFoldersActions = require("@caddigital/sok-reducers/lib/actions/vektorio/linkFolders");
var ResyncFoldersActions = require("@caddigital/sok-reducers/lib/actions/vektorio/resyncFolders");
var unlinkFoldersActions = require("@caddigital/sok-reducers/lib/actions/vektorio/detachFolders");
var mapDispatchers = function (dispatch) { return ({
    toggleSideMenu: function () { return dispatch(linkFoldersActions.toggleSideMenu()); },
    fetchLinkedFolders: function (payload) { return dispatch(linkedFoldersActions.fetchLinkedRequest(payload)); },
    resyncFolders: function (payload) {
        return dispatch(ResyncFoldersActions.request(payload));
    },
    unlinkFolder: function (payload) {
        return dispatch(unlinkFoldersActions.detachFoldersRequest(payload));
    },
    clearUnlinkState: function () { return dispatch(unlinkFoldersActions.clear()); },
    toggleModal: function () { return dispatch(unlinkFoldersActions.toggleModal()); },
    sortBy: function (key, order) {
        return dispatch(linkedFoldersActions.setOrderByOptions(key, order));
    },
    filterBy: function (key, value) {
        return dispatch(linkedFoldersActions.setFilterOptions(key, value));
    },
    clear: function () { return dispatch(linkedFoldersActions.clear()); }
}); };
exports.mapDispatchers = mapDispatchers;
